import React from 'react';
import { PricingConsolePage } from './pricing-console-page';

export function PricingConsoleModule() {
  return <PricingConsolePage />;
}
